/** 発注時支払条件(月) */
export const enum NyuMonthType {
  /** 2: 翌月 */
  _2_YOKU = 1,
  /** 3: 翌々月 */
  _3_YOKUYOKU,
  /** 4: 3ヶ月 */
  _4_3MONTH,
}

export function getNyuMonthTypeName(value: number) {
  switch (value) {
    case NyuMonthType._2_YOKU:
      return "翌月";
    case NyuMonthType._3_YOKUYOKU:
      return "翌々月";
    case NyuMonthType._4_3MONTH:
      return "3ヶ月";

    default:
      return "";
  }
}
